import React from 'react'

import { Stack, type StackProps } from '~/components/elements/Stack'

export type VStackProps = Omit<StackProps, 'direction'> & {
  reverse?: boolean
}

export const VStack = React.forwardRef<HTMLDivElement, VStackProps>(
  (
    {
      'data-testid': dataTestId = 'components-elements-v-stack',
      reverse = false,
      ...rest
    },
    ref,
  ) => (
    <Stack
      ref={ref}
      data-testid={dataTestId}
      direction={reverse ? 'column-reverse' : 'column'}
      {...rest}
    />
  ),
)
